import React, { useEffect } from 'react';

interface ClusterMapProps {
    className?: string;
}

const ClusterMap: React.FC<ClusterMapProps> = ({ className = '' }) => {
    useEffect(() => {
        try {
            // Remove existing script
            const existingScript = document.getElementById('mapmyvisitors');
            if (existingScript) {
                existingScript.remove();
            }

            // Create script element
            const script = document.createElement('script');
            script.type = 'text/javascript';
            script.id = 'mapmyvisitors';
            script.src = 'https://mapmyvisitors.com/map.js?cl=e1e1e1&w=300&t=n&d=fngBtcVXvPP4eW7t-ugYnO9uc3XJHrNYu7CAB7PGnao&co=ffffff&cmo=8c001f&cmn=d4201e&ct=ffffff';
            script.async = true;

            // Error handling
            script.onerror = () => {
                console.warn('Failed to load ClusterMap script');
            };

            const section = document.getElementById('clustermap-section');
            if (section) {
                section.appendChild(script);
            }
        } catch (error) {
            console.error('Error loading ClusterMap:', error);
        }

        return () => {
            try {
                const script = document.getElementById('mapmyvisitors');
                if (script) {
                    script.remove();
                }
            } catch (error) {
                console.error('Error cleaning up ClusterMap:', error);
            }
        };
    }, []);

    return (
        <section 
            id="clustermap-section" 
            className={`flex justify-center items-center ${className}`}
        >
            {/* Cluster map will be injected here */}
        </section>
    );
};

export default ClusterMap;